import React from "react"
import {
	Grid,
	Typography,
	Chip,
	Card,
	Box
} from "@material-ui/core"
import {
	ThumbUp as ThumbUpIcon,
	ThumbDown as ThumbDownIcon
} from "@material-ui/icons"

import { MeetingAnalysis } from "@/services/MeetingAnalyzerService"

import { phaseToDisplayText } from "@/utils/meetingAnalyzer"

import useMeetingAnalyzerStyles from "@/pages/Admin/MeetingAnalyzer/Detail/styles"
import useStyles from "@/pages/Admin/MeetingAnalyzer/Detail/AchievementAndErrorCards/styles"

type AchievementAndErrorCardsProps = {
	analysis: MeetingAnalysis
}

const AchievementAndErrorCards: React.FC<AchievementAndErrorCardsProps> = (props) => {
	const { analysis } = props

	const meetingAnalyzerClasses = useMeetingAnalyzerStyles()
	const classes = useStyles()

	const hit = analysis.output?.mainHit
	const miss = analysis.output?.mainMiss

	return (
		<Grid container spacing={3}>
			<Grid item xs={6}>
				<Card className={classes.achievementCard}>
					<Grid container direction="column" spacing={2}>
						<Grid item>
							<Grid container alignItems="center" spacing={2}>
								<Grid item>
									<Box className={classes.sentimentBadgeSuccess}>
										<ThumbUpIcon fontSize="small" />
									</Box>
								</Grid>
								<Grid item>
									<Grid container direction="column" spacing={0}>
										<Grid item>
											<Typography className={classes.achievementHeading}>
												PRINCIPAL ACERTO
											</Typography>
										</Grid>
										<Grid item>
											<Chip label={hit?.phase ? phaseToDisplayText[hit.phase] : "—"} size="small" className={classes.categoryOutlinedChipSuccess} />
										</Grid>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
						<Grid item>
							<Typography className={classes.transcriptQuote}>
								{`“${hit?.excerpt ?? ""}”`}
							</Typography>
						</Grid>
						<Grid item>
							<Typography className={meetingAnalyzerClasses.cardSubtitle}>
								{hit?.reason ?? ""}
							</Typography>
						</Grid>
					</Grid>
				</Card>
			</Grid>
			<Grid item xs={6}>
				<Card className={classes.errorCard}>
					<Grid container direction="column" spacing={2}>
						<Grid item>
							<Grid container alignItems="center" spacing={2}>
								<Grid item>
									<Box className={classes.sentimentBadgeError}>
										<ThumbDownIcon fontSize="small" />
									</Box>
								</Grid>
								<Grid item>
									<Grid container direction="column" spacing={0}>
										<Grid item>
											<Typography className={classes.errorHeading}>
												PRINCIPAL ERRO
											</Typography>
										</Grid>
										<Grid item>
											<Chip label={miss?.phase ? phaseToDisplayText[miss.phase] : "—"} size="small" className={classes.categoryOutlinedChipError} />
										</Grid>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
						<Grid item>
							<Typography className={classes.transcriptQuote}>
								{`“${miss?.excerpt ?? ""}”`}
							</Typography>
						</Grid>
						<Grid item>
							<Typography className={meetingAnalyzerClasses.cardSubtitle}>
								{miss?.reason ?? ""}
							</Typography>
						</Grid>
					</Grid>
				</Card>
			</Grid>
		</Grid>
	)
}

export default AchievementAndErrorCards
